module.exports = __webpack_public_path__ + "static/LTUnivers-BasicRegular-7520f8979ade0f8e02c5fe62d24c3124.eot";